<p class="description">{{ 'waitingForActivity' | translate }}</p>
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
